export const FROM_ID = {
  INVITE_PAGE: "invitePage",
  INVITE_SHARE_CLICK: "inviteShareClick",
  INVITE_QRCODE_CLICK: "inviteQRcodeClick",
  
  REGISTER_PAGE: "registerPage",
  
  PRE_REGISTER_PAGE: "preRegisterPage",

  DISCOVERY_PAGE: "discoveryPage",
  DISCOVERY_GOODS_CLICK: "discoveryGoodsClick"
}

export const fromJoin = (...rest) => {
  const fromList = rest.flat(10).filter(e => e)

  return fromList.join('_')
}